import { render, staticRenderFns } from "./domain-whitelist-editor.vue?vue&type=template&id=27ca657a&"
import script from "./domain-whitelist-editor.vue?vue&type=script&lang=js&"
export * from "./domain-whitelist-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports